import type { HelpFile } from '../../types/help'
import { RestrictionRuleRequestDetailTestIds } from '../../../testids/RestrictionRuleRequestDetailTestIds'

export const restrictionRuleRequestDetailHelp: HelpFile = {
  docPage: '/docs/governance/restriction-rule-requests',
  texts: {
    [RestrictionRuleRequestDetailTestIds.restrictionRuleRequestDetailPage]:
      'Restriction rule change request — proposed configuration, approval workflow, and lifecycle actions.',
    [RestrictionRuleRequestDetailTestIds.approvalChainCard]:
      'Approval chain — each step, the assigned approvers, and their decisions.',
    [RestrictionRuleRequestDetailTestIds.approvalChainEmpty]:
      'No approvers resolved yet — typically before submit.',
    [RestrictionRuleRequestDetailTestIds.cardLinkedRule]:
      'The restriction rule this request will modify, or a note that this is a CREATE request.',
    [RestrictionRuleRequestDetailTestIds.cardProposedConfig]:
      'Proposed restriction rule configuration — condition, denied profiles, and grace period.',
    [RestrictionRuleRequestDetailTestIds.cardRequestInfo]:
      'Request summary: requester, type, status, and timestamps.',
    [RestrictionRuleRequestDetailTestIds.cardTestPanel]:
      'Run the proposed condition against live identity data and inspect aggregate counts.',
    [RestrictionRuleRequestDetailTestIds.cardTitleApprovalChain]: null,
    [RestrictionRuleRequestDetailTestIds.cardTitleLinkedRule]: null,
    [RestrictionRuleRequestDetailTestIds.cardTitleProposedConfig]: null,
    [RestrictionRuleRequestDetailTestIds.cardTitleTestPanel]: null,
    [RestrictionRuleRequestDetailTestIds.btnEdit]:
      'Edit the proposed configuration while the request is still a draft.',
    [RestrictionRuleRequestDetailTestIds.btnDelete]:
      'Delete this request — cannot be undone.',
    [RestrictionRuleRequestDetailTestIds.btnRunTest]:
      'Run the proposed rule against live identity data to preview its impact.',
    [RestrictionRuleRequestDetailTestIds.btnSubmitForApproval]:
      'Submit this draft to start the approval workflow.',
    [RestrictionRuleRequestDetailTestIds.btnCancelRequest]:
      'Cancel this request before approval — cannot be undone.',
    [RestrictionRuleRequestDetailTestIds.colProfileName]: null,
    [RestrictionRuleRequestDetailTestIds.errorRejectComment]:
      'Rejection comment is missing or invalid.',
    [RestrictionRuleRequestDetailTestIds.linkLinkedRule]:
      'Open the restriction rule this request modifies.',
    [RestrictionRuleRequestDetailTestIds.linkOwnerParty]:
      'Open the detail page of the requester or owning party.',
    [RestrictionRuleRequestDetailTestIds.linkedRuleEmpty]:
      'This is a CREATE request — no existing rule is linked yet.',
    [RestrictionRuleRequestDetailTestIds.requestTypeBadge]:
      'Type of change proposed — create, update, delete, activate, or deactivate.',
    [RestrictionRuleRequestDetailTestIds.textareaApproveComment]:
      'Optional comment recorded alongside the approval decision.',
    [RestrictionRuleRequestDetailTestIds.textareaRejectComment]:
      'Reason for rejecting this request.',
  },
}
